module.exports = __webpack_public_path__ + "static/media/accessories-4.d7e10261.jpg";